import localforage from 'localforage';

import {DEFAULT_APP_STORAGE_NAME} from 'src/services/storage/types';

const _cache: Record<string, LocalForage> = {};

export const getLocalForage = (storeName: string = 'DEFAULT') => {
    if (!_cache[storeName]) {
        const _storage = localforage.createInstance({
            name: DEFAULT_APP_STORAGE_NAME,
            storeName,
            version: 1.0,
            description: 'Reffie app storage',
        });
        _storage.ready().then(() => {
            console.debug('LocalForage storage is ready: ', storeName, ',driver:', storage.driver());
        }).catch(err => {
            console.error('LocalForage storage failed to initialize: ', storeName, err);
        });

        _cache[storeName] = _storage;
    }
    const storage = _cache[storeName];

    // react hooks might lose the context of 'this' when passing methods around
    return {
        getItem: storage.getItem.bind(storage),
        setItem: storage.setItem.bind(storage),
        removeItem: storage.removeItem.bind(storage)
    };
};
